import { apiCurrentUser } from './fetcher';
import { AuthType } from '../../types/AuthType';
export default function useGetCurrentUser(setAuth: AuthType | any, auth: AuthType | any) {
	const handleGetCurrentUser = () => {
		// Get Current User
		apiCurrentUser()
			.then((data) => {
				if ('data' in data) {
					setAuth({
						currentUser: {
							id: data.data.id,
							account_no: data.data.account_no,
							nid: data.data.nid,
							name: data.data.name,
							username: data.data.username,
							company_id: data.data.company_id,
							email: data.data.email,
							profile_picture: data.data.profile_picture,
							status: data.data.status,
							status_label: data.data.status_label,
							email_template_language: data.data.email_template_language
						},
						accessToken: auth?.accessToken,
						initialState: false
					});
				}
			})
			.catch((response) => {
				console.error(response);
			});
	};

	return { handleGetCurrentUser };
}
